import React from 'react';

function WindowSizeHOC(WrappedComponent) {
  class WindowSizeFetcher extends React.Component {
    constructor() {
      super();
      this.state = { windowHeight: 0, windowWidth: 0 };
    }

    componentDidMount() {
      this.updateDimensions();
      window.addEventListener('resize', this.updateDimensions);
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.updateDimensions);
    }

    updateDimensions = () => {
      const w = window;
      const d = document;
      const { documentElement } = d;
      const body = d.getElementsByTagName('body')[0];
      const width = w.innerWidth || documentElement.clientWidth || body.clientWidth;
      const height = w.innerHeight || documentElement.clientHeight || body.clientHeight;

      this.setState({ windowWidth: width, windowHeight: height });
    };

    render() {
      const { windowWidth, windowHeight } = this.state;
      return <WrappedComponent {...this.props} windowWidth={windowWidth} windowHeight={windowHeight} />;
    }
  }

  return WindowSizeFetcher;
}

export default WindowSizeHOC;
